import { useState } from "react";
import App from "../layouts/App";

const Contact = () => {
	const [name, setName] = useState("");
	const [phone, setPhone] = useState("");
	const [message, setMessage] = useState("");
	const [loading, setLoading] = useState(false);

	return (
		<App>
			<section className="Contact">
				<div>
					<h2>Love Everyone, Everyone Needs a "Lifeline" + Help!</h2>
					<h2>Especially Us!</h2>
				</div>
				<div>
					<form
						onSubmit={(event) => {
							event.preventDefault();
							setLoading(true); // Start loading state

							// Create form data to send
							const formData = new FormData();

							formData.append("name", name);
							formData.append("number", phone);

							// Make the api request
							fetch("/api/contact", {
								method: "POST",
								body: formData,
							}).then(() => {
								setMessage("Submission successful!");
								setLoading(false); // End loading state
								setName("");
								setPhone("");
							});
						}}
						name="contact"
					>
						<input type="hidden" name="form-name" value="contact" />
						<p>
							<label>
								Name{" "}
								<input
									type="text"
									value={name}
									onChange={(e) => setName(e.target.value)}
									placeholder="Enter your name"
									required
									name="name"
								/>
							</label>
						</p>
						<p>
							<label>
								Phone Number{" "}
								<input
									type="tel"
									value={phone}
									onChange={(e) => setPhone(e.target.value)}
									placeholder="Enter your phone number"
									required
									name="phone"
								/>
							</label>
						</p>
						<p>
							<button type="submit" disabled={loading}>
								Send
							</button>
						</p>
					</form>
					{loading && <p>Loading...</p>}
					{message && <p>{message}</p>}
				</div>
			</section>
		</App>
	);
};

export default Contact;
